import request from '../request.js'

export const users = data=>{
	return request({
		url:`users?pageNo=${data.pageNo}&pageSize=${data.pageSize}`,
		method:'get'
	})
}

export const register = data => {
	return request({
		url:'register',
		method:'post',
		data
	})
}

export const updateUser = data=>{
	return request({
		url:'updatePassword',
		method:"post",
		data
	})
}

export const delUser = name => {
	return request({
		url:"deleteUser?name=" + name,
		method:"get"
	})
}